import { useGMetrixTable } from 'components/GMetrixTable/context';
import { useResponsiveDropdownMenuConfig } from 'hooks';
import { Dropdown, Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

// Structural columns that are always hidden from the table, export, and this toggle list.
const HIDDEN_COLUMN_DATA_TYPES = ['Hidden', 'Id', 'ChildId', 'ParentId'];

export const GMetrixTableColumnToggle = () => {

    const { alteredDropdownItems, setAlteredDropdownItems, uniqueTableId } = useGMetrixTable();

    const popperConfig = useResponsiveDropdownMenuConfig('md');

    const onListItemClick = (dataItem: any) => {

        const selectedColumns = alteredDropdownItems.filter(item => item.columnsDropdownSelected && !item.hidden && !item.locked).length;
        if (selectedColumns === 1 && dataItem.columnsDropdownSelected) return;

        setAlteredDropdownItems(alteredDropdownItems.map(item => item.field === dataItem.field
            ? { ...item, columnsDropdownSelected: !item.columnsDropdownSelected }
            : item
        ));

    };

    return (
        <Dropdown autoClose={'outside'} className={'gmetrix-table-column-toggle d-flex flex-fill'}>
            <Dropdown.Toggle className={'flex-fill d-inline-flex align-items-center justify-content-between'} variant={'outline-secondary'}>
                <div className={'d-flex align-items-center gap-1'}>
                    <i className={'fa-regular fa-eye-slash'} />
                    <span>
                        <FormattedMessage defaultMessage="Hide Columns" id="hide_columns.db57ada6" />
                    </span>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu renderOnMount popperConfig={popperConfig} >
                {alteredDropdownItems?.length && alteredDropdownItems.map((item, key) => (
                    <>
                        {!item.hidden && !HIDDEN_COLUMN_DATA_TYPES.includes(String(item.dataType ?? '')) && (
                            <Dropdown.Item
                                as={'div'}
                                className={'d-flex gap-2 text-nowrap'}
                                key={key}
                                onClick={() => onListItemClick(item)}
                                role="button"
                            >
                                <Form.Check
                                    checked={item.columnsDropdownSelected}
                                    id={`column_toggle_${uniqueTableId}_${key}`}
                                    type={'checkbox'}
                                />
                                <Form.Label className={'text-wrap m-0'} htmlFor={`column_toggle_${uniqueTableId}_${key}`}>
                                    {item.title || item.field}
                                </Form.Label>
                            </Dropdown.Item>
                        )}
                    </>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );

};
